import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ReactDatePicker from "react-datepicker";
import ReactSelect, { components } from "react-select";
import AsyncSelect from "react-select/async";
import CompletedField from "../CompletedField";
import SwitchToggle from "../SwitchToggle";
import AssignTo from "./assignTo/AssignTo";
import { DateRangePicker } from "rsuite";
import moment from "moment";
import CheckPicker from "rsuite/CheckPicker";
import CustomCheckPicker from "../../CustomCheckPicker";
import { IsJsonString } from "../../../Common";

const HeaderShowKanban = ({
  item,
  users,
  filters,
  param,
  advance_filter,
  assignToChangeHandler,
  groupBy,
  getFieldCompletedValue,
  completed,
  dynamicFilterChangeHandler,
  clearFormDataFilter,
}) => {
  const { filter_id, group_by, ...rest } = filters;
  const [companyData, setCompanyData] = useState([]);
  const [formdata, setFormdata] = useState({});
  const [reporterData, setReporterData] = useState([]);
  const [isloadingstate, setIsloadingState] = useState(false);
  const [projectData,setProjectData] = useState([])
  useEffect(() => {
    setFormdata((state) => {
      return {
        ...filters,
      };
    });
  }, [filters]);

  useEffect(() => {
    (function () {
      if (advance_filter && Object.keys(advance_filter)) {
        const result = {};

        for (let key in advance_filter) {
          const fieldName = advance_filter[key].field_name;
          const fieldValue = advance_filter[key].field_value;

          result[fieldName] = fieldValue;
        }

        setFormdata((form) => {
          return {
            ...form,
            ...result,
          };
        });
      }
    })();
  }, [advance_filter]);

  useEffect(() => {
    let getdatalocal = localStorage.getItem("filter");
    if (getdatalocal) {
      let newdatapar = JSON.parse(getdatalocal);
      if (newdatapar) {
        let newparsedata = newdatapar[param];
        if (newparsedata) {
          if (typeof newparsedata == "object") {
            setFormdata((state) => {
              return {
                ...state,
                ...newparsedata,
              };
            });
          } else {
            setFormdata((state) => {
              return {
                ...state,
                ...JSON?.parse(newparsedata || "{}"),
              };
            });
          }
        }
      }
    }
  }, []);
  function removeNullValues(obj) {
    for (let key in obj) {
      if (obj[key] === null) {
        delete obj[key];
      } else if (typeof obj[key] === "object") {
        if (Array.isArray(obj[key])) {
          obj[key] = obj[key].filter((item) => item !== null);
        } else {
          removeNullValues(obj[key]);
          if (Object.keys(obj[key]).length === 0) {
            delete obj[key];
          }
        }
      }
    }
    return obj;
  }

  // function for calling reporter async api

  const reporterAsynCall = async (e, api) => {
    // if (evt && reporterData.length > 0) {
    //   return reporterData.filter((itt) =>
    //     itt?.label.toLowerCase().includes(evt.toLowerCase())
    //   );
    // }
    setIsloadingState(true);
    const response = await fetch(api);
    const data = await response.json();
    if (data) {
      setIsloadingState(false);
    }
    let newdata = Object.keys(data).map((item) => ({
      label: data[item]?.name,
      value: data[item]?.user_uuid,
    }));
    setReporterData(newdata);
    // return newdata;
  };

  
    const loadAsyncProject = async (evt,api) => {
      try {
        
        api = api+evt;
  
      
        const resp = await fetch(api);
        const rdata = await resp.json();
        
        if (rdata.code === 200) {
          let transform = rdata?.data.map((item) => ({
            label: `${item.customer_tattle_uuid} - ${item.title}`,
            value: item.customer_tattle_uuid,
          }));
          
          setProjectData([...projectData, ...transform]);
          return transform;
        }
      } catch (err) {
        console.log(err.message);
      }
    }
  const companyAsyncCall = async (evt, api) => {
    try {
      if (evt && companyData.length > 0) {
        return companyData.filter((it) =>
          it.label.toLowerCase().includes(evt.toLowerCase())
        );
      }
      const rawCompanies =  [];

      const localCompanyNames = rawCompanies.map(item => (item && item.value !== undefined ? item.value : item));
  
      const requestBody = {
        search: evt || "",
        company_name: localCompanyNames,
      };
      const resp = await fetch(api, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });
      const rdata = await resp.json();
      if (rdata.code === 200) {
        let transform = rdata?.data.map((item) => ({
          label: item.value,
          value: item.id,
        }));
        setCompanyData([...companyData, ...transform]);
        return transform;
      }
    } catch (err) {
      console.log(err.message);
    }
  };
  const checkPickerHandlerAll = (e, options) => {
    const { name, checked } = e.target;
    // Handle select/deselect all logic

    let getdatalocal = localStorage.getItem("filter");

    if (getdatalocal && IsJsonString(getdatalocal)) {
      getdatalocal = JSON.parse(getdatalocal);
    }

    if (getdatalocal) {
      getdatalocal = getdatalocal[param];
    }

    let newobj = {};
    if (getdatalocal) {
      newobj = { ...getdatalocal };
    }
    if (checked) {
      newobj[name] = options.map((option) => option.value);
      setFormdata((state) => ({
        ...state,
        [item.field]: options.map((option) => option.value),
      }));
    } else {
      newobj[name] = [];
      setFormdata((state) => ({
        ...state,
        [item.field]: [],
      }));
    }

    dynamicFilterChangeHandler(newobj);
  };
  const formChangeHandler = (name) => (value) => {
    let getdatalocal = localStorage.getItem("filter");
    let newobj = {};
    if (name && name === "created_date" && value && value.length > 0) {
      let parsedata = JSON.parse(getdatalocal);
      setFormdata((state) => {
        return {
          ...state,
          ["range"]: {
            created_date:
              value && value.length > 0
                ? value && value.map((item) => convertDateFormat(item))
                : "",
          },
        };
      });

      if (parsedata) {
        let newdata = parsedata[param];
        if (typeof newdata == "object") {
          newobj = removeNullValues({
            ...newdata,
            ["range"]: {
              created_date:
                value && value.length > 0
                  ? value && value.map((item) => convertDateFormat(item))
                  : "",
            },
          });
        } else {
          newdata = JSON.parse(newdata);
          newobj = removeNullValues({
            ...newdata,
            ["range"]: {
              created_date:
                value && value.length > 0
                  ? value && value.map((item) => convertDateFormat(item))
                  : "",
            },
          });
        }
      } else {
        newobj = removeNullValues({
          ["range"]: {
            created_date:
              value && value.length > 0
                ? value && value.map((item) => convertDateFormat(item))
                : "",
          },
        });
      }

      for (let key in newobj) {
        if (
          newobj[key] &&
          newobj[key]?.hasOwnProperty("created_date") &&
          !newobj[key]["created_date"]
        ) {
          delete newobj[key];
        }
      }
      dynamicFilterChangeHandler(newobj);
      return;
    } else {
      if (name === "created_date") {
        setFormdata((state) => {
          return {
            ...state,
            ["range"]: {
              created_date: "",
            },
          };
        });

        const newform = { ...formdata };

        if (newform.hasOwnProperty("range")) {
          delete newform["range"];
        }

        dynamicFilterChangeHandler(newform);
        return;
      } else {
        // let keys = Object.keys(evt)[0];
        // let values = Object.values(evt)[0];
        if (Array.isArray(value)) {
          setFormdata((state) => {
            return {
              ...state,
              [name]: value,
            };
          });
          if (getdatalocal) {
            let parsedata = JSON.parse(getdatalocal);
            if (parsedata) {
              let newdata = parsedata[param];
              if (typeof newdata == "object") {
                newobj = removeNullValues({
                  ...newdata,
                  [name]: value,
                });
              } else {
                let alldata = JSON.parse(newdata || "{}");
                newobj = removeNullValues({
                  ...alldata,
                  [name]: value.map((irr) => irr.value),
                });
              }
            }
          }
          dynamicFilterChangeHandler(newobj);
        } else {
          setFormdata((state) => {
            return {
              ...state,
              [name]: value || "",
            };
          });
          if (getdatalocal) {
            let parsedata = JSON.parse(getdatalocal);
            if (parsedata) {
              let newdata = parsedata[param];
              if (typeof newdata == "object") {
                newobj = removeNullValues({
                  ...newdata,
                  [name]: value,
                });
              } else {
                let newparsedata = JSON.parse(newdata);
                newobj = removeNullValues({
                  ...newparsedata,
                  [name]: value,
                });
              }
            }
          } else {
            newobj = removeNullValues({
              [name]: value,
            });
          }
          dynamicFilterChangeHandler(newobj);
        }
      }
    }
  };
  const reactSelectChangeHandler = (field,value) => {
    
    
    let newobj ={}

    newobj ={
      ...formdata,
      [field]: value
    }
    setFormdata(newobj)

    dynamicFilterChangeHandler(newobj);
  }

  const convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };
  const customStyles = {
    control: (styles, state) => {
      return {
        ...styles,
        fontSize: "12px",
        textAlign: "left",
        boxShadow: "none",
        height: state.selectProps?.className === "isLarge" && 100,
        overflowY: "auto",
        // width: 230,
      };
    },
  };

  if (item.attribute_type === "category") {
    const options = item?.options?.map((opt) => ({
      label: opt.name,
      value: opt._id || opt.id,
    }));

    let vall = options.filter((itt) => itt.value == formdata[item.field]);
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <CustomCheckPicker
          options={options}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />
      </div>
    );
  } else if (
    item.attribute_type == "select" ||
    item.attribute_type == "priority"
  ) {
    const options = item?.options?.map((opt) => ({
      label: opt.option_name,
      value: opt._id || opt.id,
    }));

    let vall = options.filter((itt) => itt.value == formdata[item.field]);

    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <CustomCheckPicker
          options={options}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />
      </div>
    );
  } else if (item.attribute_type == "status") {
    const options = item?.options?.map((opt) => ({
      label: opt.name,
      value: opt._id || opt.id,
    }));
    let vall = options.filter((itt) => itt.value == formdata[item.field]);
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <CustomCheckPicker
          options={options}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />
      </div>
    );
  }
  if (
    item.attribute_type == "start_date" ||
    item.attribute_type == "end_date"
  ) {
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <ReactDatePicker />
      </div>
    );
  } else if (item.attribute_type === "reporter") {
    let vall = reporterData.filter((itt) => itt.value == formdata[item.field]);
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        {/* <AsyncSelect
          cacheOptions
          defaultOptions
          value={vall}
          loadOptions={(evt) => reporterAsynCall(evt, item.api_url)}
          isClearable
          // isMulti
          styles={customStyles}
          onChange={(evt) => formChangeHandler({ [item.field]: evt })}

          // onChange={(evt) => statusChangehandler(evt, "company_name")}
        /> */}
        <CustomCheckPicker
          options={reporterData || []}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          apiUrl={item.api_url}
          onOpen={reporterAsynCall}
          block={true}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />
      </div>
    );
  } else if (item.attribute_type == "text") {
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <input
          type="text"
          className="form-control"
          style={{ width: "100%" }}
          onChange={(evt) => formChangeHandler({ [item.field]: evt })}
        />
      </div>
    );
  }

  // we are now moving this filter assign to to header
  // else if (item.attribute_type == "assign_to") {
  //   //&& groupBy === "assign_to" to analize purpose -> remove
  //   return (
  //     <div className="col-auto">
  //       <label>{item.headerName}</label>
  //       <AssignTo
  //         users={users}
  //         filter={formdata?.assign_to}
  //         assignToChangeHandler={assignToChangeHandler}
  //         groupBy={groupBy}
  //         headerName={item.headerName}
  //       />
  //     </div>
  //   );
  // }
  else if (
    item.attribute_type == "checkbox" &&
    item.field == "completed"
    // state.boarddata.attribute_set_type === 4
  ) {
    const { options } = item || {};
    return (
      <div className="header-filter-class dd">
        <label>{item.headerName}</label>
        <SwitchToggle
          getFieldCompletedValue={getFieldCompletedValue}
          filters={completed}
        />
      </div>
    );
  } else if (item.attribute_type == "api" || item.attribute_type == "release") {
    const options = item?.options?.map((opt) => ({
      label: opt.value,
      value: opt.id,
    }));
    let val = options.filter((it) => {
      if (formdata.hasOwnProperty("filters")) {
        return formdata?.filters[item.field]?.includes(it.value);
      } else {
        return (
          formdata &&
          formdata.hasOwnProperty(item.field) &&
          formdata?.[item.field].includes(it.value)
        );
      }
    });

    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>

        <CustomCheckPicker
          options={options}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />
        {/* <ReactSelect
          options={options}
          value={val || ""}
          isClearable
          // isMulti
          className={val?.length > 2 ? "isLarge" : ""}
          onChange={(evt) => formChangeHandler({ [item.field]: evt })}
          styles={customStyles}
        />*/}
      </div>
    );
  }else if (item.attribute_type == "people" || item.attribute_type =="monitoring" || item.attribute_type =="account_manager" || item.attribute_type =="sales_manager"|| item.attribute_type =="tse_owner") {
   
    let options = [];
    
    if(users) {
      options = Object.keys(users).map(key => ({label: users[key]?.name, value:users[key]?.user_uuid}))
    }
        return (
          <div className="header-filter-class">
            <label>{item.headerName}</label>
            
            <CustomCheckPicker
              options={options}
              formdata={formdata}
              field={item.field}
              formChangeHandler={formChangeHandler}
              checkPickerHandlerAll={checkPickerHandlerAll}
            />
           
          </div>
        );
      }else if (item.attribute_type == "toggle") {
       
        let options = [{label: "Yes", value:true},{label:"No", value:false}];
        
    
            return (
              <div className="header-filter-class">
                <label>{item.headerName}</label>
                
                <CustomCheckPicker
                  options={options}
                  formdata={formdata}
                  field={item.field}
                  formChangeHandler={formChangeHandler}
                  checkPickerHandlerAll={checkPickerHandlerAll}
                />
               
              </div>
            );
          }  else if (item.attribute_type == "product") {
    const options = item?.options?.map((opt) => ({
      label: opt.value,
      value: opt.id,
    }));
    let val = options.filter((it) => {
      if (formdata.hasOwnProperty("filters")) {
        return formdata?.filters[item.custom_field]?.includes(it.value);
      } else {
        return (
          formdata &&
          formdata.hasOwnProperty(item.custom_field) &&
          formdata?.[item.custom_field]?.includes(it.value)
        );
      }
    });

    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <ReactSelect
          options={options}
          value={val || ""}
          isMulti={true}
          className={val?.length > 2 ? "isLarge" : ""}
          onChange={(evt) => formChangeHandler({ [item.custom_field]: evt })}
          styles={customStyles}
        />
      </div>
    );
  } else if (item.attribute_type == "project") {
   
    
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>  
        <AsyncSelect
              cacheOptions
              defaultOptions
              value={formdata[item.field] ? projectData.filter((itm) =>
                formdata[item.field]?.includes(itm.value)
              ) : ""}
              loadOptions={(evt) => loadAsyncProject(evt, item.api_url)}
              isClearable
              isMulti={true}
              styles={customStyles}
              onChange={(evt) => reactSelectChangeHandler(item.field, Array.isArray(evt) ? evt.map(item => item.value) : evt.value)}
        />
      </div>
    );
  } else if (item.attribute_type === "company_name") {
    return (
      <div className="header-filter-class">
        <label>{item.headerName}</label>
        <CustomCheckPicker
          options={companyData || []}
          formdata={formdata}
          field={item.field}
          formChangeHandler={formChangeHandler}
          apiUrl={item.api_url}
          onOpen={companyAsyncCall}
          block={true}
          checkPickerHandlerAll={checkPickerHandlerAll}
        />

        {/* <AsyncSelect
          cacheOptions
          defaultOptions
          // value={companies.filter((item) =>
          //   data[filterData.field]?.includes(item.value)
          // )}
          loadOptions={(evt) => companyAsyncCall(evt, item.api_url)}
          isClearable
          isMulti={true}
          styles={customStyles}
          onChange={(evt) => formChangeHandler({ [item.field]: evt })}

          // onChange={(evt) => statusChangehandler(evt, "company_name")}
        /> */}
        {/* <ReactSelect
          // options={options}
          // value={val || ""}
          // isMulti
          // className={val?.length > 2 ? "isLarge" : ""}
          onChange={(evt) => formChangeHandler({ [item.field]: evt })}
          styles={customStyles}
        /> */}
      </div>
    );
  } else if (item.attribute_type === "subdate") {
    return (
      <div className="header-filter-class">
        <label>{"Submit Date"}</label>
        <DateRangePicker
          className="custom-date-range-picker"
          onChange={formChangeHandler("created_date")}
          value={
            !formdata?.["range"]?.["created_date"]
              ? ""
              : formdata["range"] &&
                formdata["range"]["created_date"] &&
                formdata["range"]["created_date"].map((item) =>
                  Date.parse(item)
                )
          }
          placeholder="Select Date Range"
          showOneCalendar
        />
      </div>
    );
  }
  // else {

  //   return (
  //     <span className="mainHead">
  //       <label>{item.headerName}</label>
  //       <ReactSelect
  //         // options={options}
  //         // value={val || ""}
  //         isMulti
  //         // className={val?.length > 2 ? "isLarge" : ""}
  //         onChange={(evt) => formChangeHandler({ [item.field]: evt })}
  //         styles={customStyles}
  //       />
  //     </span>
  //   );
  // }
};

export default React.memo(HeaderShowKanban);
